var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"home",class:{ 'auto-padding': _vm.noSubMenu }},[(!_vm.isEmbed)?_c('website-menu',{attrs:{"fixed":_vm.noSubMenu}}):_vm._e(),_vm._t("default"),(!_vm.isEmbed)?_c('website-footer'):_vm._e()],2)}
var staticRenderFns = []

export { render, staticRenderFns }